export interface MessageTypesState {
  messageTypes: any[],
  messageTypeItem?: MessageTypeItem
}

export interface MessageTypeFilter {
  name?: string
}

export interface MessageTypeItem {
  id?: number
  name: string,
  description: string,
  blacklist_ids?: number[]
}

export class MessageTypeItemImpl implements MessageTypeItem {
  name: string;
  description: string;
  blacklist_ids?: number[]

  constructor() {
    this.name = '';
    this.blacklist_ids = [];
    this.description = '';
  }
}
